<template>
  <div id="liveList">
    <div class="list-img">
      <img src="../../assets/images/banner.png"/>
    </div>
    <div class="list-content">
     <div style="background-color:white;min-height: 50px;width: 180px;">
       <div  v-for="(item ,index) in hosList" :class="{to_active:shows==item.sn}" @click="getHospital(item.sn)" style="border-top: 1px solid #E4E4E4; height: 50px;width: 180px;line-height:50px;text-align: center">• {{item.hosName}}</div>
     </div>
      <div class="list" v-if="shows==1">
            <div class="case-item"  v-for="(item ,index) in liveInfo">
              <a :href="item.liveUrl" target="_blank"><img :src="item.img"></a>
              <h5>{{item.liveName}}</h5>
              <p>
                {{item.hosName}}&nbsp&nbsp{{item.doctorName}}&nbsp&nbsp{{item.doctorTitle}}
              </p>
              <p>
                {{item.liveTime}}
              </p>
            </div>
      </div>
    </div>

  </div>
</template>

<script  type="text/javascript">
  export default {
    components:{},
    data () {
      return {
        index: 0,
        lives: {},
        shows:'',
        liveInfo:this.$global_variable.liveInfo,
        hosList:this.$global_variable.hosList,
      }
    },
    mounted () {
  },
    destroyed () {
    },
    methods:{
      getHospital(type){
        if(type===type){
          this.shows=type
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .to_active {background: #F5F5F5!important;color: #0079FE;}
</style>



// WEBPACK FOOTER //
// src/components/live/LiveList.vue